import React from "react";
import { FacilityOrderEditTemplate } from "themes/application/facility-order/pages";
import { observer } from "mobx-react";
import { FacilityOrderEditViewStore } from "application/facility-order/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderEditViewStore(rootStore), "facilityOrderEditViewStore")
@observer
class FacilityOrderEdit extends React.Component {
	render() {
		return <FacilityOrderEditTemplate {...this.props} />;
	}
}

export default FacilityOrderEdit;